/* global Set */

export const SHOPIFY_DATA = {
    gcproduct: [],
    general: [],
    cards: [],
};

export function save_gcproduct_data(
    product,
    ispromo,
    position,
    collection_title,
    price,
    img_url,
    featured
) {
    SHOPIFY_DATA.gcproduct.push({
        product: product,
        ispromo: ispromo,
        position: position,
        collection_title: collection_title,
        product_price: price,
        img_url: img_url,
        featured: featured,
    });
}

export function save_general_data(product, category_name, ispromo, img_url) {
    SHOPIFY_DATA.general.push({
        product: product,
        category: category_name,
        ispromo: ispromo,
        img_url: img_url,
    });
}

export function first_collection(product_collections) {
    let ignore = new Set([
        'All Gifts',
        'Under $30',
        'Most Popular',
        'Most Needed',
    ]);
    for (let c in product_collections) {
        if (!ignore.has(c.title)) {
            return c;
        }
    }

    let err = {
        msg: 'No collection found',
        data: product_collections,
    };
    throw err;
}
